import type BackOfficeConnector from "../data/backOfficeConnector";
import RepositoryBase from "./repositoryBase";
import type EventBus from "../services/eventBus";
import AdhocReportRequestResponse from "../entities/adhocReportRequestResponse";
import type AdHocReportRequest from "../entities/adHocReportRequest";
import { serializeFilters } from "../utils/filters";
import { AdHocReportFile } from "../entities/adHocReportRequest";
import CreateAdHocReportRequestResponse from "entities/createAdHocReportRequestResponse";

export default class AdHocReportsRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll() {
    return this.callApi(api => api.all("reports").all("ad_hoc_reports").getEntities(AdhocReportRequestResponse));
  }

  generateNewReport(filter: AdHocReportRequest) {
    return this.callApi(api =>
      api
        .all("reports")
        .all("ad_hoc_reports")
        .postEntity({ ...serializeFilters(filter, false) }, CreateAdHocReportRequestResponse)
    );
  }

  downloadReport(id: string) {
    return this.callApi(api => api.all("reports").one("ad_hoc_reports", id).getEntity(AdHocReportFile));
  }
}
